/**
 * Type check guard for "defined".
 */
export const def = <T>(value: T | undefined | null): value is T => value !== undefined && value !== null;
